__webpack_require__.p = "https://syllabus-dev.apps.asu.edu/";